import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IDeclarationsProps extends IProcessComponentProps {}

interface IDeclarationsState {
    checkedDeclarations: number[];
}

export class Declarations extends ProcessComponent<IDeclarationsProps, IDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            checkedDeclarations: [],
        };
    }

    isValid() {
        if (this.state.checkedDeclarations.length < 2) {
            this.props.showErrorMsgPopUp(["You must accept all items to continue"], true);
        }

        return super.isValid() && this.state.checkedDeclarations.length == 2;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                <h2>Declarations</h2>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Lifetime allowance",
                            value: this.state.checkedDeclarations.includes(1),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(1) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 1) });
                                }
                            },
                        },
                    ]}
                />
                <p>
                    The information supplied by me is true and complete to the best of my client's knowledge as at the
                    date of this declaration. I understand that any false statement may result in HM Revenue & Custom
                    imposing penalties on the client.
                </p>
                <p>
                    I understand that a Lifetime Allowance Charge, where applicable, will be deducted from the SIPP and
                    paid to HM Revenue & Customs.
                </p>
                <p>
                    My client agrees to indemnify Standard Life Assurance Limited (SLAL) against any liability to pay
                    any tax or other charges which occur due to the provision of false or misleading information.
                </p>
                <p>
                    Any payment by Standard Life Assurance Limited (SLAL) of the benefitts under this SIPP shall
                    constitute a full discharge from all liabilities and claims arising in respect of the pension monies
                    applied in this Benefit Crystallisation Event request.
                </p>
                <p>
                    Any tax-free lump sum will not be used to fund further contributions to any registered pensions
                    scheme to the extent that either Standard Liufe Assurance Limited (SLAL) or I will suffer a tax
                    liability.
                </p>
                <p>
                    I confirm that the client gives Standard Life Assurance Limited (SLAL) the authority to check with
                    HM Revenue & Customs the detyails of any LTA protection certificate supplied.
                </p>
                <p>
                    I can confirm that I have provided my client with an illustration in relation to this withdrawal, in
                    line with my regulatory responsibilities as financial adviser, as detailed in FCA Sourcebook COBS
                    14.
                </p>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Evidence of age",
                            value: this.state.checkedDeclarations.includes(2),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(2) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 2) });
                                }
                            },
                        },
                    ]}
                />
                <p>I confirm that I have seen appropriate evidence of age.</p>
                <p>This can be either:</p>
                <p>A valid driving license or passport, or</p>
                <p>A birth certificate</p>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm all",
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.length == 2,
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ checkedDeclarations: [1, 2] });
                                } else {
                                    this.setState({ checkedDeclarations: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
